import { render, staticRenderFns } from "./input-select-year.vue?vue&type=template&id=3c1317d8&"
import script from "./input-select-year.component.ts?vue&type=script&lang=ts&"
export * from "./input-select-year.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports